import { Dtos, SuretyAccountId, SuretyQuoteId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { bondRequestBondFormQueryKey, bondRequestsQueryKey } from "../bond-request.keys";
import { redirectToIssuedBond } from "../utils";

export const useUpdateBondForm = (accountId: SuretyAccountId, id: SuretyQuoteId) => {
	const queryClient = useQueryClient();
	const { put } = useRequest();

	const mutation = useMutation({
		meta: { redirectOnError: redirectToIssuedBond },
		mutationKey: ["updateBondForm", id],
		mutationFn: async (data: Dtos.SuretyBondForm.Update.Request) => {
			return await put(`/v2/surety/accounts/${accountId}/quotes/${id}/bond-form`, data);
		},
		onSuccess: async (_) => {
			queryClient.invalidateQueries({ queryKey: bondRequestsQueryKey(id) });
			queryClient.invalidateQueries({ queryKey: bondRequestBondFormQueryKey(id) });
		},
	});

	return {
		updateBondForm: mutation.mutate,
		updateBondFormIsLoading: mutation.isPending,
		updateBondFormError: mutation.error,
	};
};
